document.body.innerHTML = document.body.innerHTML.replace(
  /®/g,
  "<sup class='-top-[0.35em]'>®</sup>",
)
